// Tracks which 3D analysis feature is currently open: 'terrain' | 'viewshed' | 'checkWind' | null.
// Lets TerrainAnalysis, Viewshed and Check Wind close each other without prop drilling.

const _listeners = new Set()
let _active = null

export const activeFeatureStore = {
  get active() { return _active },

  set(v) {
    _active = v
    _listeners.forEach(fn => fn())
  },

  onChange(fn) {
    _listeners.add(fn)
    return () => _listeners.delete(fn)
  },
}
